import { RefreshCw } from "lucide-react";
import { useApp } from "../../context";
import "./main.css";

export function Toast() {
  const app = useApp();
  return (
    <div className="toast-area" aria-live="polite">
      {app.updateAvailable && (
        <button className="toast update" onClick={() => app.updateAvailable?.()}>
          <RefreshCw size={14} /> 有新版本，点此刷新
        </button>
      )}
      {app.toast && (
        <button key={app.toast.id} className="toast" onClick={() => app.dismissToast()}>
          {app.toast.text}
        </button>
      )}
    </div>
  );
}
